import { useEffect, useState } from "react";

/**
 * Reference-style FlipClock (allpanel9 admin): two digit <ul class="flip play">,
 * each with the previous digit (li.flip-clock-before) and the current one
 * (li.flip-clock-active). Styled/animated by styles/flipclock.css + index.css.
 * Countdown behaviour is the same as FlipperTimer: counts down 1/s from initialTime.
 */
function FlipDigit({ value }) {
  // Previous digit shown in li.flip-clock-before; updated when the value changes.
  const [digits, setDigits] = useState({ value, prev: value === 0 ? 9 : value - 1 });
  if (digits.value !== value) setDigits({ value, prev: digits.value });
  const { prev } = digits;

  return (
    <ul className="flip play">
      <li key={`b-${prev}-${value}`} className="flip-clock-before">
        <a href="#" onClick={(e) => e.preventDefault()}>
          <div className="up">
            <div className="shadow" />
            <div className="inn">{prev}</div>
          </div>
          <div className="down">
            <div className="shadow" />
            <div className="inn">{prev}</div>
          </div>
        </a>
      </li>
      <li key={`a-${value}`} className="flip-clock-active">
        <a href="#" onClick={(e) => e.preventDefault()}>
          <div className="up">
            <div className="shadow" />
            <div className="inn">{value}</div>
          </div>
          <div className="down">
            <div className="shadow" />
            <div className="inn">{value}</div>
          </div>
        </a>
      </li>
    </ul>
  );
}

export default function FlipClock({ initialTime = 0, className = "casino-timer" }) {
  // Counts down 1/s from initialTime (restarts whenever initialTime changes).
  const [clock, setClock] = useState({ start: initialTime, elapsed: 0 });
  if (clock.start !== initialTime) setClock({ start: initialTime, elapsed: 0 });

  useEffect(() => {
    const interval = setInterval(() => {
      setClock((c) => (c.start - c.elapsed > 0 ? { ...c, elapsed: c.elapsed + 1 } : c));
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const timeLeft = Math.max(0, (Number(clock.start) || 0) - clock.elapsed);
  const digits = String(Math.max(0, Number(timeLeft) || 0) % 100).padStart(2, "0");

  return (
    <div className={`${className} clock flip-clock-wrapper`}>
      <FlipDigit value={Number(digits[0])} />
      <FlipDigit value={Number(digits[1])} />
    </div>
  );
}
